import React from 'react'

import Button from 'components/Button'
import Modal from 'components/Modal'
import { ModalInjectedProps } from 'containers/ModalManager'
import DownloadFileAnchor from 'components/DownloadFile'
import { useShareRestoreWithUi } from './RestoreShareModal'
import { canRestoreShare, getDownloadProps } from 'modules/shares/utils'

import { ShareListItemFragment } from 'gqlTypes'

interface ShareForShareTrashedModal
  extends Pick<
    ShareListItemFragment,
    'identifier' | 'name' | 'userAccessLevel' | 'version'
  > {}

export interface ShareTrashedModalProps extends ModalInjectedProps {
  share: ShareForShareTrashedModal
}

export const ShareTrashedModal: React.FC<ShareTrashedModalProps> = ({
  share,
  hideModal,
}) => {
  const [restoreShare, { loading }] = useShareRestoreWithUi({
    identifier: share.identifier,
    onCompleted: () => {
      hideModal()
    },
  })

  const download = getDownloadProps(share.version)

  return (
    <Modal title="Cannot Open Document in Trash" onCancel={hideModal}>
      <Modal.Body>
        <p>
          You cannot open “{share.name}” because it&apos;s in the Workspace
          Trash.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={loading} onClick={hideModal} variant="secondary">
          Close
        </Button>
        {download?.isAvailable && (
          <Button
            to="#"
            variant="secondary"
            href={download.url}
            as={DownloadFileAnchor}>
            Download
          </Button>
        )}
        {canRestoreShare(share) && (
          <Button
            data-testid="restore-document"
            variant="secondary"
            loading={loading}
            disabled={loading}
            onClick={() => restoreShare()}>
            Restore
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  )
}
